__turbopack_context__.v({
  "blackAndWhite": "IconButton-module-scss-module__lwclba__blackAndWhite",
  "blue": "IconButton-module-scss-module__lwclba__blue",
  "container": "IconButton-module-scss-module__lwclba__container",
  "extraSmall": "IconButton-module-scss-module__lwclba__extraSmall",
  "medium": "IconButton-module-scss-module__lwclba__medium",
  "small": "IconButton-module-scss-module__lwclba__small",
  "transparent": "IconButton-module-scss-module__lwclba__transparent",
  "white": "IconButton-module-scss-module__lwclba__white",
  "whiteAlert": "IconButton-module-scss-module__lwclba__whiteAlert",
  "withBorder": "IconButton-module-scss-module__lwclba__withBorder",
});
